const IP = process.env.NODE_ENV === 'production' ? 'https://nomu.strategy-offsite-meeting.com/api' : 'https://snb-nomu-be.onrender.com/api';
// const IP = 'https://nomu.strategy-offsite-meeting.com/api';


export default IP;
